import { render, staticRenderFns } from "./OrgElementComponentStruktur.vue?vue&type=template&id=2002f258&lang=pug"
import script from "./OrgElementComponentStruktur.vue?vue&type=script&lang=js"
export * from "./OrgElementComponentStruktur.vue?vue&type=script&lang=js"
import style0 from "./OrgElementComponentStruktur.vue?vue&type=style&index=0&id=2002f258&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports